module.exports = "/images/mandarin-untuk-dewasa.jpg?39b07dbd9a328bc80854f1c4892ec37e";